lmApp
  .directive('lmWaves', ['$timeout',
    function ($timeout) {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          var waveMe = function (event) {
            var ripple = element.find('.ripple');

            if (ripple.length === 0) {
              ripple = angular.element('<span/>', {
                class: 'ripple'
              });

              if (attrs.lmWaves) {
                ripple.addClass('bgc-' + attrs.lmWaves);
              }

              element.prepend(ripple);
            }

            ripple.removeClass('ripple--is-animated');

            if (!ripple.height() && !ripple.width()) {
              var diameter = Math.max(element.outerWidth(), element.outerHeight());

              ripple.css({height: diameter, width: diameter});
            }

            var x = event.pageX - element.offset().left - ripple.width() / 2;
            var y = event.pageY - element.offset().top - ripple.height() / 2;

            ripple.css({top: y + 'px', left: x + 'px'}).addClass('ripple--is-animated');

            scope.rippleTimeout = $timeout(function () {
              ripple.removeClass('ripple--is-animated');
            }, 850);
          };

          element
            .css({
              position: 'relative',
              overflow: 'hidden'
            })
            .bind('mousedown', waveMe);

          element.on('$destroy', function () {
            element.unbind('mousedown', waveMe);
            $timeout.cancel(scope.rippleTimeout);
          });
        }
      };
    }]);
